import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { api } from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const check = useCallback(() => api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false)), []);
  useEffect(() => { check(); }, [check]);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };
  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="auth-checking" data-testid="auth-checking">Vérification de la session…</div>;
  if (!user) return <Navigate to={`/admin?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return children;
};

export const formatError = (detail) => {
  if (!detail) return "Une erreur est survenue, réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return detail.msg || String(detail);
};
